import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="stream-dark min-h-screen flex items-center justify-center text-white/60">Učitavanje…</div>;
  if (!user) return <Navigate to={admin ? "/admin/login" : "/login"} replace />;
  if (admin && user.role !== "ADMIN") return <Navigate to="/dashboard" replace />;
  if (!admin && user.role === "ADMIN") return <Navigate to="/admin/dashboard" replace />;
  return children;
}
